<template>
  <div :class="detailClass()">
    <div class="dates__date" v-if="show_more">
      <div class="dates__title">Night x {{ numDays }}</div>
      <div class="dates__value">{{ price }}</div>
    </div>
    <div class="dates__date" v-if="show_more" v-for="requiredFee in requiredFees">
      <div class="dates__title">{{ requiredFee.name }}</div>
      <div class="dates__value">${{ requiredFee.value }}</div>
    </div>
    <div class="dates__date" v-if="show_more && extrasApplied">
      <div class="dates__title">Extra Fees</div>
      <div class="dates__value">{{ extraFees }}</div>
    </div>
    <div class="dates__date" v-if="show_more && promoApplied">
      <div class="dates__title">Discount</div>
      <div class="dates__value">{{ discount }}</div>
    </div>
    <div class="dates__date" v-if="show_more">
      <div class="dates__title">Taxes</div>
      <div class="dates__value">{{ taxes }}</div>
    </div>
    <div class="dates__date total-price" v-if="show_more">
      <div class="dates__title">Total</div>
      <div class="dates__value">{{ total }}</div>
    </div>
    <div class="dates__date ammount-paid" v-if="ammountPaid">
      <div class="dates__title">Paid</div>
      <div class="dates__value">{{ ammountPaid }}</div>
    </div>
    <div class="dates__date due-now" v-if="show_more">
      <div class="dates__title" v-html="dueText()"></div>
      <div class="dates__value">{{ dueToday }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: [
    'show_more',
    'descriptor'
  ],
  computed: {
    ...mapGetters([
      'listing',
      'total',
      'dueToday',
      'deposit',
      'price',
      'numDays',
      'discount',
      'promoApplied',
      'taxes',
      'fees',
      'extraFees',
      'extrasApplied',
      'ammountPaid',
      'requiredFees'
    ])
  },
  methods: {
    detailClass() {
      let classes = ['detailed-totals']
      if (this.descriptor) classes.push(this.descriptor)
      if (this.show_more) classes.push('expanded')
      return classes.join(' ')
    },
    dueText() {
      return this.$store.state.app_data.step == 'confirmation' ? 'Balance Due' : 'Due Now'
    }
  }
}
</script>

<style>
#template-confirmation-view {

}
</style>
